module.exports = {"130582001":"褡裢街道","130582002":"桥东街道","130582003":"桥西街道","130582004":"赞善","130582005":"周庄街道","130582101":"新城镇","130582102":"白塔镇","130582103":"十里亭镇","130582104":"綦村镇","130582201":"册井乡","130582202":"刘石岗乡","130582203":"柴关乡","130582204":"蝉房乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130582.json
// module id = 151
// module chunks = 0